import { UserService } from '../../../services/user.service';
var PdfViewerFooterComponent = /** @class */ (function () {
    function PdfViewerFooterComponent(userService) {
        this.userService = userService;
    }
    PdfViewerFooterComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(PdfViewerFooterComponent.prototype, "logoImage", {
        get: function () {
            return this.userService.logoImage;
        },
        enumerable: true,
        configurable: true
    });
    return PdfViewerFooterComponent;
}());
export { PdfViewerFooterComponent };



// WEBPACK FOOTER //
// ./src/app/main/pdf-viewer/pdf-viewer-footer/pdf-viewer-footer.component.ts.pre-build-optimizer.js